import axios from 'axios';
import { captureQueryError, TResponse } from '~/src/api/helper';
import { IProviderDto } from '~/src/store/reducers/city';

const PROVIDER_API_ENDPOINT = process.env.PROVIDER_API_ENDPOINT;

interface IProps {
    sector: string;
    operatorId: string;
    cityId: number;
}


export type TProviderResponse = TResponse<IProviderDto, any>;

export const getProviderId = async(data: IProps): Promise<TProviderResponse> => {
    try {
        const response = await axios({
            url: `${PROVIDER_API_ENDPOINT}/web/v1/providers`,
            params: {
                ...data
            },
        });

        return {
            isSuccess: true,
            payload: response.data
        };
    } catch (error) {
        return captureQueryError(error);
    }
};
